import {BasicCartItem} from 'components/common/BasicCartItem'
import {Exp1, Ventrata} from 'types'

type Props = {
  booking: Ventrata.Booking
  exp1Product: Exp1.Product | null
}

export const CartItem = ({booking, exp1Product}: Props) => {
  return (
    <div className="border-solid border-x border-gray-4">
      <BasicCartItem booking={booking} exp1Product={exp1Product} render={(cartItemData) => cartItemData} />
    </div>
  )
}
